









import { Vue, Component, Prop } from 'vue-property-decorator';

import FormReserved from './FormReserved.vue';
import FormConsultation from './FormConsultation.vue';

import { SelectItem } from '@/components/select/types';
import { Slot, SlotType } from '../types';

@Component({
    components: {
        FormReserved,
        FormConsultation,
    },
})
export default class SlotForm extends Vue {
    @Prop({ required: true }) event!: Slot
    @Prop({ default: () => [] }) clinic!: SelectItem

    get formComponent() {
        if (this.event.type === SlotType.Reserved) {
            return FormReserved;
        }

        return  FormConsultation;
    }

    get clinicForEvent(): SelectItem {
        const slotClinic: any = (this.event as any).clinic;

        // если у слота уже есть своя клиника — используем её
        if (slotClinic) {
            if ('value' in slotClinic) {
                return slotClinic as SelectItem;
            }

            if ('title' in slotClinic) {
                return {
                    id: slotClinic.id,
                    value: slotClinic.title,
                } as SelectItem;
            }
        }

        // иначе fallback на клинику дня
        return this.clinic;
    }
}
